import type { SVGProps } from 'react';
const SvgIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    height={8}
    width={8}
    {...props}
  >
    <rect fill="currentColor" height={8} width={8} rx={4} x={4} y={4} />
  </svg>
);
export default SvgIndicator;
